import { Link } from "react-router-dom";

export function Logo({ variant = "full", className = "" }) {
  if (variant === "icon") {
    return (
      <Link to="/" data-testid="brand-logo-link" className={`inline-flex items-center ${className}`}>
        <img src="/assets/logo-icon.png" alt="COCARDE Pizza" className="h-11 w-11 object-contain" />
      </Link>
    );
  }
  return (
    <Link to="/" data-testid="brand-logo-link" className={`inline-flex items-center ${className}`}>
      <img
        src="/assets/logo-full.png"
        alt="COCARDE Pizza"
        className="h-10 sm:h-12 w-auto object-contain shrink-0"
      />
    </Link>
  );
}
